export default __webpack_public_path__ + "static/media/DJ.961787d4.svg";